export const PromotionAction = (json: IPromotionAction): IPromotionActionModel => {
	const fromJSON = (itemJson: IPromotionAction) => {
		const { ...rest } = itemJson
		return {
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const promotionActionToJSON = (obj: Partial<IPromotionActionModel>): Partial<IPromotionAction> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}
